import React from 'react';
import { Props } from '.';
import CardIcon from '../../../../components/card-icon/CardIcon';
import { CardTypeEnum, EventTypeEnum, EventVm } from '../../../../utils/api';

/** Team sanction row: same 4-slot layout as coach rows (yellow / red slot / exclusion slot / label) but only yellow is interactive — red & penalty slots are blank. */
class MatchTeamYellowRow extends React.PureComponent<Props> {
    public render = (): React.ReactElement => {
        const { match, events, isHomeTeam, initEvent, activeEvent } = this.props;

        if (!match) {
            return <></>;
        }

        const teamId = isHomeTeam ? match.homeTeamId : match.awayTeamId;

        const teamCardEvents = events.filter(
            (e: EventVm): boolean =>
                e.typeId === EventTypeEnum.Card &&
                e.card?.teamId === teamId &&
                !e.card?.cardedCoachId &&
                !e.card?.cardedPlayerId
        );
        const yellowCardEvents = teamCardEvents.filter(
            (e: EventVm): boolean => e.card?.typeId === CardTypeEnum.Yellow
        );

        let isEditingTeamYellow = false;
        if (activeEvent?.typeId === EventTypeEnum.Card) {
            isEditingTeamYellow =
                activeEvent.card?.teamId === teamId &&
                activeEvent.card?.typeId === CardTypeEnum.Yellow &&
                !activeEvent.card?.cardedCoachId &&
                !activeEvent.card?.cardedPlayerId;
        }

        const editCardYellow = isEditingTeamYellow;

        const yellowCard = (
            <div
                key={1}
                onClick={
                    match
                        ? (): void =>
                              initEvent(EventTypeEnum.Card, {
                                  teamId: teamId,
                                  typeId: CardTypeEnum.Yellow,
                              })
                        : undefined
                }
                className={`c-team__btn c-team__btn--yellow-card${
                    editCardYellow ? ' c-team__btn--editing' : ''
                }`}
                role="button"
            >
                <div className="c-team__btn-inner">
                    <span className="fake-svg">
                        <CardIcon type={CardTypeEnum.Yellow} />
                    </span>
                </div>
            </div>
        );

        const placeholderRed = (
            <div key={2} className="c-team__btn c-team__btn--coach-slot-inert" aria-hidden="true">
                <div className="c-team__btn-inner" />
            </div>
        );

        const placeholderExclusion = (
            <div key={3} className="c-team__btn c-team__btn--coach-slot-inert" aria-hidden="true">
                <div className="c-team__btn-inner" />
            </div>
        );

        const teamLabel = (
            <div key={4} className="c-team__btn c-team__btn--coach-slot-team-label">
                <div className="c-team__btn-inner">
                    <span className="fake-svg">Team</span>
                </div>
            </div>
        );

        const render = [yellowCard, placeholderRed, placeholderExclusion, teamLabel];

        const rowMods: string[] = [];
        if (yellowCardEvents.length > 0) {
            rowMods.push('c-team__row--is-yellow-card-active');
        }

        return (
            <div
                className={`c-team__row c-team__row--single c-team__row--${
                    isHomeTeam ? 'white' : 'blue'
                }-team c-team__row--coach-lineup c-team__row--team-yellow-sanction ${rowMods.join(
                    ' '
                )}${isEditingTeamYellow ? ' c-team__row--active-event' : ''}`}
            >
                {render}
            </div>
        );
    };
}

export default MatchTeamYellowRow;
